import LoginForm from "../components/LoginForm";
import Firma from "../components/Firma";

const Login = () => {
    return (
        <div className="h100 bg-primary d-flex">
            <div className="col-4  h-100 d-none  d-md-flex flex-column align-items-center justify-content-center">
                <h3 className="fs-3"><Firma bg={"dark"} /></h3>
                <small className="text-white">Aministración el sistema</small>
            </div>
            <div
                className="flex-grow-1 h-100 bg-light rounded-start shadow-lg d-flex flex-column justify-content-center align-items-center"
            >
                <LoginForm />
            </div>

        </div>
    )

}
export default Login;
